<template>
  <section class="config-overview">
    <div class="header">
      <h2>{{ data.title }}</h2>
      <p class="note">{{ data.note }}</p>

      <div class="naming">
        <h4>{{ data.naming.title }}</h4>
        <p class="desc">{{ data.naming.description }}</p>
        <ul>
          <li v-for="(ex, i) in data.naming.examples" :key="i">
            {{ ex }}
          </li>
        </ul>
      </div>
    </div>

    <div class="cards">
      <div v-for="(item, index) in data.items" :key="item.model" class="card">
        <div class="card-header" @click="toggle(index)">
          <div>
            <h3>{{ item.model }}</h3>
            <p class="grade">{{ item.grade }}</p>
          </div>
          <!-- 只在移动端显示折叠图标 -->
          <span
            v-if="!isDesktop"
            class="arrow"
            :class="{ open: openIndex === index }"
            >+</span
          >
        </div>

        <div class="card-body" v-show="isDesktop || openIndex === index">
          <p class="tagline">{{ item.tagline }}</p>
          <p class="description">{{ item.description }}</p>

          <ul class="highlights">
            <li v-for="(h, i) in item.highlights" :key="i">
              {{ h }}
            </li>
          </ul>

          <p class="recommend">
            <strong>Recommended for:</strong> {{ item.recommendedFor }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ConfigurationOverview",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openIndex: 0,
      isDesktop: false,
    };
  },
  mounted() {
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreen);
  },
  methods: {
    toggle(index) {
      if (this.isDesktop) return;
      this.openIndex = this.openIndex === index ? -1 : index;
    },
    checkScreen() {
      this.isDesktop = window.innerWidth > 768;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";

.config-overview {
  padding: 60px 40px;
  background: @color-bg-gray;

  .header {
    max-width: 900px;
    margin-bottom: 48px;

    h2 {
      font-size: 28px;
      font-weight: @font-weight-semibold;
      color: @color-text-title;
      margin-bottom: 12px;
    }

    .note {
      font-size: 15px;
      color: @color-text-sub;
      line-height: 1.6;
      margin-bottom: 24px;
    }

    .naming {
      background: @color-bg-main;
      border: 1px solid #dde5e0;
      border-radius: @radius-base;
      padding: 16px 20px;

      h4 {
        font-size: 15px;
        color: @color-text-title;
        margin-bottom: 6px;
      }

      .desc {
        font-size: 14px;
        color: @color-text-sub;
        margin-bottom: 8px;
      }

      ul {
        padding-left: 16px;

        li {
          font-size: 14px;
          color: @color-text-content;
          line-height: 1.6;
        }
      }
    }
  }

  .cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 20px;

    .card {
      background: @color-bg-main;
      border: 1px solid #dde5e0;
      border-radius: @radius-base;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        cursor: pointer;

        h3 {
          font-size: 18px;
          color: @color-text-title;
          margin-bottom: 2px;
        }

        .grade {
          font-size: 13px;
          color: @color-text-sub;
        }

        .arrow {
          font-size: 22px;
          color: @color-text-sub;
          transition: transform 0.2s ease;

          &.open {
            transform: rotate(45deg);
          }
        }
      }

      .card-body {
        padding: 0 20px 20px;

        .tagline {
          font-size: 14px;
          color: @color-text-content;
          margin-bottom: 8px;
        }

        .description {
          font-size: 14px;
          color: @color-text-sub;
          margin-bottom: 10px;
        }

        .highlights {
          padding-left: 16px;
          margin-bottom: 10px;

          li {
            font-size: 14px;
            color: @color-text-sub;
            line-height: 1.6;
          }
        }

        .recommend {
          font-size: 13px;
          color: @color-text-sub;

          strong {
            color: @color-text-title;
            font-weight: @font-weight-medium;
          }
        }
      }
    }
  }
}

@media (max-width: @breakpoint-mobile) {
  .config-overview {
    padding: 40px 20px;
  }
}
</style>
